module.exports = __webpack_public_path__ + "media/images/icons/close-icon-832697a8199d71e40b7aa404574162c8.svg";